module.exports = __webpack_public_path__ + "static/media/3s.6f5ce696.png";